import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { update } from '../../../app/setters/update.js'
import { useKeycloak } from '@react-keycloak/web'

export const useZmien2FA = () => {
    const queryClient = useQueryClient()
    const { keycloak } = useKeycloak()

    return useMutation({
        mutationFn: () => update('/uzytkownik/zmiana-2fa', {}),
        onSuccess: async (data) => {
            if (data?.status === 'success') {
                await queryClient.invalidateQueries({
                    queryKey: ['moje_dane'],
                })
                toast.success(data?.message || 'Dokonano zmiany ustawien 2FA.')
                keycloak.logout()
                return
            }

            toast.error(data?.message || 'Nie udalo sie zmienic ustawien 2FA.')
        },
        onError: () => {
            toast.error('Blad podczas zmiany ustawien 2FA.')
        },
    })
}
